module.exports = __webpack_public_path__ + "media/softinyalms-de.85fe2dbd.mp4";